import { Client } from '../js-sdk/src';
import store from '../store';
import { ClientConnector } from './sdkConnector/ClientConnector';

let connector;

const startFakeConv = async () => {
  // change follow to POST v5/patient/login once implemented
  await connector.client.signIn('user2@boenaa.com', 'tigertext');
  // need to run this to load all orgs into js-sdk models?
  await connector.client.organizations.findAll();

  const patientData = {
    api_key: 'yGDBabtVW34T2FjO6jKA64SUnc1GNwNR',
    api_secret: 'SbKu6lGL8uE3fSM3eIHnvBdTpFhzQpeBQVGni9Jij8pcLUHY',
    conversation_id: '4JddgezQQvHWQScE8Ew8yCu9G6bZcNNdFToxXDPVjsuNTsADTfmEjKLwJXZq1YoFAuvSX4Gd5ufnuSi9S8uhBGJPPpcGuum9',
    organization_id: 'HiO8NW67Dqt3yuOPvRw7A4N7',
    session_tokens: [
      {
        account_token: '15d841bb-1fef-4db6-92d2-d9a6b7fbf1a8',
        session_token: 'SXlERlVnbXNOdWNlM2JYaERRS0',
      },
    ],
  };
  connector.store.dispatch.patient.setPatient(patientData);

  // just taking the first org for now, change this later to use the org id from the POST login call
  const organizationData = connector.client.organizations.getAll();
  connector.store.dispatch.organization.setOrganization(organizationData[0]);

  const roster = await connector.client.conversations.findAll();
  for (const conv of roster) {
    if (conv.counterPartyType === 'group' && conv.lastMessage) {
      connector.selectConversation(conv);
      break;
    }
  }
};

export const getConnector = () => {
  if (!connector) {
    connector = new ClientConnector(Client, store);
    startFakeConv();
  }

  return connector;
};
